import NetworkMembersTable from './NetworkMembersTable';

export default NetworkMembersTable;
